import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from "../classNames.js";
import { modifier, sizeClassName, } from "../modifiers/index.js";
export const Modal = ({ children, className, isActive, ...props }) => {
    const _class = classNames("modal", modifier({ isActive }), className);
    return (_jsx("div", { className: _class, ...props, children: children }));
};
export const ModalBackground = ({ className, ...props }) => {
    const _class = classNames("modal-background", className);
    return _jsx("div", { className: _class, ...props });
};
export const ModalCard = ({ children, header, footer, className, }) => {
    const _class = classNames("modal-card", className);
    return (_jsxs("div", { className: _class, children: [header && (_jsx("header", { className: "modal-card-head", children: _jsx("p", { className: "modal-card-title", children: header }) })), _jsx("div", { className: "modal-card-body", children: children }), footer ? _jsx("footer", { className: "modal-card-foot", children: footer }) : null] }));
};
export const ModalClose = ({ className, size, ...props }) => {
    const _class = classNames("modal-close", sizeClassName(size), className);
    return _jsx("button", { className: _class, "aria-label": "close", ...props });
};
export const ModalContent = ({ children, className, ...props }) => {
    const _class = classNames("modal-content", className);
    return (_jsx("div", { className: _class, ...props, children: children }));
};
